export const CHAT_TABLE_WRAPPER_CLASS =
  'my-3 overflow-x-auto rounded-lg border border-gray-200';
export const CHAT_TABLE_CLASS = 'w-full text-sm border-collapse';
export const CHAT_TABLE_HEAD_CLASS = 'bg-gray-50';
export const CHAT_TABLE_TH_CLASS =
  'px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-gray-500 border-b border-gray-200 whitespace-nowrap';
export const CHAT_TABLE_TD_CLASS = 'px-3 py-2 align-top border-b border-gray-100 tabular-nums';
export const CHAT_TABLE_TR_CLASS = 'even:bg-gray-50/40';
export const CHAT_TABLE_TEXT_SELECT = { userSelect: 'text', WebkitUserSelect: 'text' };

export default function ChatTableShell({ children, className = '' }) {
  return (
    <div className={`${CHAT_TABLE_WRAPPER_CLASS} ${className}`.trim()}>
      {children}
    </div>
  );
}
